import { IArticle, IQuantityPerUnit } from '@alberta/konexi-shared';

/** Packungseinheit, wie die Historie sie zum Anzeigen braucht. */
export type IIntegratedCareHistoryPackagingUnit = Pick<IQuantityPerUnit, '_id' | 'unit' | 'quantity'>;

/**
 * Artikelstammdaten, die ein Historieneintrag zum Anzeigen braucht, festgehalten beim Schreiben des
 * Eintrags (#27525). Ältere Einträge haben sie nicht; die Historienzeile löst den Artikel dann aus
 * dem Artikelstamm auf.
 */
export interface IIntegratedCareHistoryArticle extends Pick<
  IArticle,
  '_id' | 'name' | 'customerNumber' | 'description'
> {
  packagingUnits: IIntegratedCareHistoryPackagingUnit[];
}

export function toIntegratedCareHistoryArticle(article: IArticle): IIntegratedCareHistoryArticle {
  return {
    _id: article._id,
    name: article.name,
    customerNumber: article.customerNumber,
    description: article.description,
    packagingUnits: (article.packagingUnits ?? []).map(({ _id, unit, quantity }) => ({ _id, unit, quantity })),
  };
}
